import type { LayoutSection } from '../types/dashboard-preferences';

import metaIcon from '../assets/platforms/meta.svg';
import googleAdsIcon from '../assets/platforms/google-ads.svg';
import tiktokIcon from '../assets/platforms/tiktok.svg';
import tiktokShopIcon from '../assets/platforms/tiktok-shop.svg';
import pinterestIcon from '../assets/platforms/pinterest.svg';
import amazonAdsIcon from '../assets/platforms/amazon-ads.svg';
import amazonSellerIcon from '../assets/platforms/amazon-seller.svg';
import shopifyIcon from '../assets/platforms/shopify.svg';

export const PLATFORM_ICONS: Readonly<Record<string, string>> = {
  meta: metaIcon,
  google_ads: googleAdsIcon,
  tiktok_ads: tiktokIcon,
  tiktok_business: tiktokIcon,
  tiktok_shop: tiktokShopIcon,
  pinterest: pinterestIcon,
  amazon_ads: amazonAdsIcon,
  amazon: amazonSellerIcon,
  amazon_seller: amazonSellerIcon,
  shopify: shopifyIcon,
};

export const CHANNEL_COLORS: Readonly<Record<string, string>> = {
  meta: '#1877F2',
  google_ads: '#34A853',
  tiktok_ads: '#FF004F',
  tiktok_business: '#FF004F',
  tiktok_shop: '#25F4EE',
  pinterest: '#E60023',
  amazon_ads: '#FF9900',
  amazon: '#E88B2D',
  amazon_seller: '#E88B2D',
  shopify: '#96BF48',
  klaviyo: '#8C43FF',
  ga4: '#F9AB00',
};

/** Canonical display labels for all channel/platform keys used in the API. */
export const CHANNEL_LABELS: Readonly<Record<string, string>> = {
  meta: 'Meta',
  google_ads: 'Google Ads',
  tiktok_ads: 'TikTok Ads',
  tiktok_business: 'TikTok Ads',
  tiktok_shop: 'TikTok Shop',
  pinterest: 'Pinterest',
  amazon_ads: 'Amazon Ads',
  amazon: 'Amazon Seller',
  amazon_seller: 'Amazon Seller',
  shopify: 'Shopify',
  klaviyo: 'Klaviyo',
  ga4: 'Google Analytics',
};

/** Convert a raw channel key to a user-friendly display name. */
export function getChannelLabel(key: string): string {
  return CHANNEL_LABELS[key] ?? key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Platforms in "coming soon" state: their section and pinned widgets are
 * never rendered on the dashboard and appear disabled in the SectionEditor,
 * regardless of connection status.
 */
export const COMING_SOON_PLATFORMS: ReadonlySet<string> = new Set(['pinterest']);

export function isComingSoonPlatform(channelKey: string): boolean {
  return COMING_SOON_PLATFORMS.has(channelKey);
}

export const DEFAULT_SECTIONS: readonly LayoutSection[] = [
  { channelKey: 'meta', platform: 'Meta', visible: true, collapsed: false },
  { channelKey: 'google_ads', platform: 'Google Ads', visible: true, collapsed: false },
  { channelKey: 'tiktok_ads', platform: 'TikTok', visible: true, collapsed: false },
  { channelKey: 'pinterest', platform: 'Pinterest', visible: false, collapsed: false },
  { channelKey: 'amazon_ads', platform: 'Amazon Ads', visible: true, collapsed: false },
  { channelKey: 'shopify', platform: 'Shopify', visible: true, collapsed: false },
  { channelKey: 'tiktok_shop', platform: 'TikTok Shop', visible: true, collapsed: false },
  { channelKey: 'amazon', platform: 'Amazon', visible: true, collapsed: false },
];
